/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobAcceptedResponseFromDiscriminatorValue, serializeAbandonedImageAssetsJobRequest, serializeJobAcceptedResponse, type AbandonedImageAssetsJobRequest, type ErrorResponse, type InternalErrorResponse, type JobAcceptedResponse } from '../../../models/index.js';
// @ts-ignore
import { ProgressRequestBuilderNavigationMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs/abandoned-image-assets-clean-up
 */
export interface AbandonedImageAssetsCleanUpRequestBuilder extends BaseRequestBuilder<AbandonedImageAssetsCleanUpRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
    /**
     * Reconciles the image CDN's stored assets against the image documents: assets whose id belongs to an in-scope organization but has no image document are reported as abandoned and, unless dryRun is true (the default), moved to the trash - recoverable via the restore endpoint until the retention purge. Assets without an organization prefix (logos, placeholders, samples) or under an out-of-scope organization are only counted, never touched. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobAcceptedResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: AbandonedImageAssetsJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobAcceptedResponse | undefined>;
    /**
     * Reconciles the image CDN's stored assets against the image documents: assets whose id belongs to an in-scope organization but has no image document are reported as abandoned and, unless dryRun is true (the default), moved to the trash - recoverable via the restore endpoint until the retention purge. Assets without an organization prefix (logos, placeholders, samples) or under an out-of-scope organization are only counted, never touched. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AbandonedImageAssetsJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AbandonedImageAssetsCleanUpRequestBuilderUriTemplate = "{+baseurl}/api/jobs/abandoned-image-assets-clean-up";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AbandonedImageAssetsCleanUpRequestBuilderNavigationMetadata: Record<Exclude<keyof AbandonedImageAssetsCleanUpRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        navigationMetadata: ProgressRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AbandonedImageAssetsCleanUpRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AbandonedImageAssetsCleanUpRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobAcceptedResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAbandonedImageAssetsJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
